import { CloseCircleOutlined } from '@ant-design/icons'
import styled from 'styled-components'

const StyledUnknownWordsModalCloseIcon = styled(CloseCircleOutlined)`
  background-color: #fff;
  border-radius: 1rem;
  font-size: 32px;
  position: absolute;
  right: -1rem;
  top: -1rem;
`

export default StyledUnknownWordsModalCloseIcon
